import { viewSchemas } from "@redotech/redo-views-common/views";
import * as z from "zod";

export const upsertOrderTrackingOrderView = {
  name: "upsertOrderTrackingOrderView" as const,
  input: z.object({ view: viewSchemas["order-tracking-orders"] }),
  output: z.object({}),
};
